export enum AdminVisionDetectionsRoutes {
  GetOne = 'get-one',
  GetByFireID = 'get-by-fire-id',
  GetMissedDetectionsHistory = 'get-missed-detections-history',
}
